module.exports = __webpack_public_path__ + "img/frame (63).c44a2190.jpg";